export default __webpack_public_path__ + "static/media/mb.37efdabb.webp";